import { Link } from "react-router-dom";
import { Eyebrow } from "../Eyebrow";
import { RDV_URL } from "../../lib/api";
import { TestimonialCarousel } from "./TestimonialCarousel";

export const HomeHero = () => (
    <section className="bg-navy text-white">
        <div className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-10 md:py-16 lg:py-[88px] flex flex-wrap gap-8 md:gap-12 items-center">
            <div className="flex-[1.45_1_480px] min-w-0 flex flex-col gap-5 md:gap-6 animate-fade-up">
                <Eyebrow onNavy>
                    <span className="block">Optimisation des frais bancaires</span>
                    <span className="block mt-1">PME &amp; ETI</span>
                </Eyebrow>
                <h1 className="m-0 font-bold text-[32px] sm:text-5xl lg:text-[60px] leading-[1.18] tracking-[-0.02em] text-white">
                    Vos frais bancaires, relus par ceux qui les <span className="text-gold">facturaient.</span>
                </h1>
                <p className="m-0 text-base md:text-lg leading-relaxed text-on-navy max-w-[540px]">
                    Des anciens banquiers auditent chaque ligne de vos relevés, puis renégocient avec vos banques.
                    Mission menée en trois semaines en moyenne.
                </p>
                <div className="flex flex-col sm:flex-row sm:flex-wrap sm:justify-center gap-3">
                    <Link
                        to="/simulateur"
                        data-testid="hero-simulator-cta"
                        className="w-full sm:w-auto inline-flex items-center justify-center h-[52px] px-6 rounded-md bg-gold text-navy text-base font-semibold transition-[transform,box-shadow] hover:-translate-y-[1px] hover:shadow-lg"
                    >
                        Simuler mes économies
                    </Link>
                    <a
                        href={RDV_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-rdv-cta"
                        className="w-full sm:w-auto inline-flex items-center justify-center h-[52px] px-6 rounded-md border border-white text-white text-base font-semibold transition-colors hover:bg-white hover:text-navy"
                    >
                        Prendre rendez-vous
                    </a>
                </div>
            </div>
            <TestimonialCarousel />
        </div>
    </section>
);
